module.exports = __webpack_public_path__ + "img/8.5c7a2f00.jpg";